module.exports = __webpack_public_path__ + "img/invert_mbp_logo.68adf2bf.png";